import { baseApi } from '../Api';
import api from '@/api/api';

export const FILE_DOWNLOAD_ENDPOINT = '/OrganizationService/api/File/get';

export const fileDownloadApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    downloadFile: builder.mutation({
      async queryFn(filePath) {
        try {
          const encodedPath = encodeURIComponent(filePath);
          const response = await api.get(`${FILE_DOWNLOAD_ENDPOINT}?path=${encodedPath}`, {
            responseType: 'blob',
          });
          
          // Create a blob URL and trigger download
          const blob = new Blob([response.data], {
            type: response.headers['content-type'] || 'application/octet-stream',
          });
          const url = window.URL.createObjectURL(blob);
          const fileName = filePath.split('/').pop() || 'download';
          
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          
          return { data: { success: true } };
        } catch (axiosError) {
          const err = axiosError;
          return {
            error: {
              status: err.response?.status ?? -1,
              data: err.response?.data ?? err.message,
            },
          };
        }
      },
    }),
  }),
});

export const { useDownloadFileMutation } = fileDownloadApi;
